import React from "react";
import { connect } from "react-redux";
import { getNotificacionesPorUsuario } from "./NotificacionService";
import Spinner from "react-bootstrap/Spinner";
import ComponenteVacio from "../componentes/avisos/ComponenteVacio";
import { Link } from "react-router-dom";
import ModalNotificacion from "./ModalNotificacion";
import { username } from "../../constans/constants";

class NoLeidas extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      pageSize: 10,
      search: "",
      loading: true,
      notificaciones: [],
      totalCount: 0,
      totalPages: 0,
      openModal: false,
      idNotificacion: null,
    };
  }

  componentDidMount() {
    this.fetchNotificaciones(0, this.state.pageSize, "");
  }

  fetchNotificaciones(page, pageSize, search) {
    this.setState({ loading: true });
    this.props.getNotificacionesPorUsuario(page, pageSize, search,false).then(() => {
      this.setState({
        notificaciones: this.props.notificacionesData.notificaciones,
        page: this.props.notificacionesData.page,
        totalCount: this.props.notificacionesData.totalCount,
        totalPages: Math.ceil(
          this.props.notificacionesData.totalCount / pageSize
        ),
        loading: false,
      });
    });
  }

  handleSearchChange = (e) => {
    const searchValue = e.target.value;
    this.setState({ search: searchValue }, () => {
      this.fetchNotificaciones(0, this.state.pageSize, this.state.search);
    });
  };

setOpenModal = (valor, idNotificacion = null) => {
  this.setState({ openModal: valor, idNotificacion: idNotificacion });
}

  handlePageChange = (newPage) => {
    if (newPage >= 0 && newPage < this.state.totalPages) {
      this.setState({ page: newPage }, () => {
        this.fetchNotificaciones(newPage, this.state.pageSize, this.state.search);
      });
    }
  };

  // Clase CSS para el estado de la notificación
  getStatusClass = (estado) => {
    switch (estado) {
      case "Leída":
        return "label__success";
      case "Sin leer":
        return "label__info";
      case "Pendiente":
        return "label__default";
      default:
        return "label__info";
    }
  };

  renderNotificacion = (notificacion, index) => {
    return (
      <div
        key={index}
        className={`list-item ${
          notificacion.tipo.codigo === "03"
            ? "type-danger"
            : notificacion.tipo.codigo === "01"
            ? "type-warning"
            : "type-info"
        }`}
        onClick={() => this.setOpenModal(true,notificacion.id)}
      >
          <div className="item-info">
            {/* Icono */}
            <div className="icon-shape">
              <span className="material-symbols-outlined"> notifications </span>
            </div>

            {/* Texto */}
            <div className="item-copy">
              <span className="copy__uppertitle">{notificacion.nombreCreador}</span>
              <h3 className="copy__title">{notificacion.titulo}</h3>
              <p className="copy__description">{notificacion.resumen}</p>
            </div>
          </div>

          <div className="item-elements">
            <div className="item__status">
              <span className={this.getStatusClass(notificacion.estado.descripcion)}>
                {notificacion.estado.descripcion}
              </span>
            </div>
            <time className="item__date" dateTime={notificacion.fechaEnvio}>
              {new Date(notificacion.fechaEnvio).toLocaleDateString("es-ES", {
                day: "numeric",
                month: "short",
                year: "numeric",
              })}
            </time>
          </div>
{/*         <div className="item-actions">
          <button className="btn-small btn-primary-tonal btn-circle-icon">
            <span className="material-symbols-outlined">content_copy</span>
            <span className="mobile-txt">Copiar</span>
          </button>
          <button className="btn-small btn-primary-tonal btn-circle-icon">
            <span className="material-symbols-outlined">delete</span>
            <span className="mobile-txt">Eliminar</span>
          </button>
        </div> */}
      </div>
    );
  };

  render() {
    return (
      <div className="component-lista-documentos">
        <div className="component-container">
          <h5 className="list-title">Notificaciones</h5>

          {/* Buscador */}
          <form className="search-form form">
            <div className="search-group">
              <div className="input-icon">
                <span className="material-symbols-outlined">search</span>
              </div>
              <input
                type="search"
                className="input-search"
                placeholder="Buscar.."
                aria-label="Search"
                value={this.state.search}
                onChange={this.handleSearchChange}
              />
            </div>
          </form>
      <ModalNotificacion
        open={this.state.openModal}
        onClose={() => this.setOpenModal(false)}
        idNotificacion={this.state.idNotificacion}
        username={username()}
      />
          {/* Lista */}
          {this.state.loading ? (
            <div className="d-flex justify-content-center p-5">
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Cargando...</span>
              </Spinner>
            </div>
          ) : this.state.notificaciones.length > 0 ? (
            this.state.notificaciones.map(this.renderNotificacion)
          ) : (
            <ComponenteVacio />
          )}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  getNotificacionesPorUsuario: (page, size, search,leido) =>
    dispatch(getNotificacionesPorUsuario(page, size, search,leido)),
});

const mapStateToProps = (state) => ({
  notificacionesData: state.notificacionesData,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NoLeidas);
